import React from "react";
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, ButtonBase, IconButton, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import LogoSection from "./LogoSection";
import * as SVGIcons from "../components/SVGIcons/SVGIcons";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { SET_THEME_MODE } from "../store/actions";

const Menuicon = SVGIcons.MenuIcon;

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const customization = useSelector((state) => state.customization);
  const isDark = customization.themeMode === "dark";

  const handleToggleTheme = () => {
    dispatch({ type: SET_THEME_MODE });
  };

  return (
    <>
      <Box
        sx={{
          width: 228,
          display: "flex",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        <Box
          component="span"
          sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }}
          aria-label="Logo Section"
        >
          <LogoSection />
        </Box>
        <ButtonBase
          sx={{
            borderRadius: "12px",
            overflow: "hidden",
          }}
          aria-label="Menu Button"
        >
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: "all .2s ease-in-out",
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.dark,
              "&:hover": {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light,
              },
            }}
            alt="menu list"
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <Menuicon stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      {/* Dark Mode Toggle */}
      <Tooltip title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}>
        <IconButton
          onClick={handleToggleTheme}
          sx={{
            mr: 1,
            color: isDark ? "#ffd54f" : theme.palette.secondary.dark,
            transition: "all 0.3s ease",
            "&:hover": { background: isDark ? "rgba(255,213,79,0.1)" : theme.palette.secondary.light }
          }}
          aria-label="Toggle dark mode"
        >
          {isDark ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
      </Tooltip>

      
    </>
  );
};

export default Header;

